import React from "react";
import Button from "@mui/material/Button";

/**
 * @param {{ rows: import("../../../utils/redemptionSubscriptionPicker").SubscriptionPickerRow[], onSelect: (id: string) => void, disabled?: boolean }} props
 */
export default function RedemptionSubscriptionPicker({ rows, onSelect, disabled }) {
  if (!rows?.length) return null;

  return (
    <div className="mt-4 text-left">
      <p className="text-sm font-medium mb-2">
        Multiple subscriptions found. Select the membership to redeem:
      </p>
      <div className="flex flex-col gap-2">
        {rows.map((row) => (
          <Button
            key={row.id}
            variant="outlined"
            disabled={disabled || !row.selectable}
            onClick={() => row.selectable && onSelect(row.id)}
            sx={{
              justifyContent: "flex-start",
              textAlign: "left",
              textTransform: "none",
              opacity: row.selectable ? 1 : 0.65,
            }}
          >
            <div className="w-full">
              <div className="font-medium">{row.productName}</div>
              <div style={{ fontSize: "0.75rem", opacity: 0.85 }}>
                {row.statusLabel}
                {row.expiryLabel ? ` · ${row.expiryLabel}` : ""}
                {` · ID ${row.idSuffix}`}
              </div>
              <div style={{ fontSize: "0.75rem", opacity: 0.7 }}>{row.vehicleLabel}</div>
              {!row.selectable && row.blockedReason && (
                <div style={{ fontSize: "0.75rem", color: "#b45309", marginTop: 4 }}>
                  {row.blockedReason}
                </div>
              )}
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
}
